import {css, useTheme} from "@emotion/react";
import { Link } from "react-router-dom";
import PropTypes from "prop-types";


const Logo = ({ src, alt }) => {

  const theme = useTheme();
  const logoCss = css(`
    width: 18.3rem;
    height: 4rem;
    margin-right: 4rem;
    @media (min-width: ${theme.mobileNavBp}px) and (max-width: 1170px) {
             margin-right: 0;
             width: 17rem;
        }

    a {
      display: block;
      position: relative;
      top: -4px;
      padding: 0.8rem 0.8rem 0.8rem 0 ;
    }

    img {
      width: 100%;
      height: auto;
    }
  `);

  return (
    <div css={logoCss}>
      <Link to={'/'}>
        <img
          src={src}
          alt={alt}
          title={alt}
        />
      </Link>
    </div>
  );
};

Logo.propTypes = {
  src: PropTypes.string,
  alt: PropTypes.string,
};

export default Logo;
